import React from "react";
import {SelectId} from "./SelectId";

const PostcodeOptions = [
    {id:null,label:''},
    {id:'^E[0-9]',label:'London Eastern (E*)'},
    {id:'^EC',label:'London Eastern Central (EC*)'},
    {id:'^N[0-9]',label:'London Northern (N*)'},
    {id:'^SE',label:'London South Eastern (SE*)'},
    {id:'^SW',label:'London South Western (SW*)'},
    {id:'^W[0-9]',label:'London Western (W*)'},
    {id:'^WC',label:'London Western Central (WC*)'}
]

export const PostcodeAreaSelect = (props) => {
    return <SelectId options={PostcodeOptions} {...props} labelField="label" />;
}
